import * as FS from '@fullstory/browser';

function deactivate() {
  FS.shutdown();
}

function reactivate() {
  FS.restart();
}

export default {
  deactivate,
  reactivate,
};
